import React from 'react'
import { LogOut, Menu } from 'lucide-react'

const Header = ({ user, onLogout, toggleSidebar }) => {
  const userName = user?.displayName || user?.email || 'User'
  

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white border-b border-gray-200 px-4 py-3 flex justify-between items-center">
      {/* Left section: Logo + Hamburger */}
      <div className="flex items-center gap-3">
        {/* Hamburger icon for mobile */}
        <button
          onClick={toggleSidebar}
          className="lg:hidden text-gray-600 hover:text-gray-800 focus:outline-none"
        >
          <Menu size={24} />
        </button>

        {/* Logo */}
        <div className="flex items-center gap-2">
          <img src="https://www.theengage.in/images/log.jpg" alt="Logo" className="h-8" />
          <span className="hidden sm:inline font-bold text-lg text-gray-700">
            the<span className="text-yellow-600">engage.in</span>
          </span>
        </div>
      </div>

      {/* Middle section: Search bar (optional) */}
      <div className="hidden md:flex flex-1 mx-6">
        <input
          type="text"
          placeholder="Search for tools, features, and more"
          className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-100 text-sm"
        />
      </div>

      {/* Right section: User Info & Logout */}
      <div className="flex items-center gap-4">
        <span className="text-sm font-medium text-gray-700 truncate max-w-[120px]">{userName}</span>
        <button
          onClick={onLogout}
          className="flex items-center gap-1 text-red-600 hover:text-red-800 text-sm"
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </header>
  )
}

export default Header
